<div *ngIf="showStore$ | async">

  <div class="storebg"></div>
  <div class="parch"></div>
  <div class="sm:container 
              sm:mx-auto 
              sm:max-w-5xl
              bg-white
              ">
    <tea-shop-fe-top-navigation></tea-shop-fe-top-navigation>
  
    <router-outlet></router-outlet>

    <tea-shop-fe-site-footer></tea-shop-fe-site-footer>
  </div>
</div>

<a href="/vulnerability-disclosure-program" style="position: absolute; left: -9999px;">Vulnerability Disclosure Program</a>

<div *ngIf="maintenanceMode$ | async">
  <div class="storebg"></div>
  <div class="parch"></div>

  <div class="sm:container 
              sm:mx-auto 
              sm:max-w-5xl
              bg-white
              ">
    <tea-shop-fe-maintenance-mode></tea-shop-fe-maintenance-mode>
  </div>
</div>


<div *ngIf="comingSoon$ | async">
  <div class="storebg"></div>
  <div class="parch"></div>

  <div class="sm:container 
              sm:mx-auto 
              sm:max-w-5xl
              bg-white
              ">
    <tea-shop-fe-coming-soon></tea-shop-fe-coming-soon>
  </div>
</div>

<ng-container *ngTemplateOutlet="(securing$ | async) ? securing : null"></ng-container>

<ng-template #securing>
  <div class="storebg"></div>
  <div class="parch"></div>
  
  <div class="sm:container sm:mx-auto sm:max-w-5xl bg-white p-8 text-center">
    <div class="flex flex-col items-center space-y-6">
      <svg class="w-16 h-16 text-green-600 animate-pulse" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
      
      <h2 class="text-2xl font-bold text-gray-800">Securing Your Connection</h2>
      
      <p class="text-gray-600 max-w-md">
        We're establishing a secure connection to ensure your tea shopping experience is safe and private. This should only take a moment.
      </p>
      
      <p class="text-gray-600 max-w-md text-sm italic">
        While we specialise in fine teas, we take your security and privacy very seriously. 
        Every connection to our store is protected with industry-standard encryption.
      </p>
      
      <div class="flex items-center space-x-2 text-sm text-gray-500">
        <svg class="w-5 h-5 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span>Establishing secure connection...</span>
      </div>
    </div>
  </div>
</ng-template>
